import { useState } from "react";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import AppVersionReportList from "../../component/reports/app-version-report/AppVersionReportList";

function AppVersionReports() {
  const { t } = useTranslation();
  const [selectedAppName, setSelectedAppName] = useState("");
  const [selectedVersion, setSelectedVersion] = useState("");
  const [searchWord, setSearchWord] = useState("");
  const [selectedOrganization, setSelectedOrganization] =
    useState("Linnk group");

  return (
    <div className="page-body">
      <Breadcrumbs
        mainTitle={t("App Version Reports")}
        parent={t("Reports")}
        parentLink={`${process.env.PUBLIC_URL}/reports`}
      />

      <AppVersionReportList
        selectedAppName={selectedAppName}
        setSelectedAppName={setSelectedAppName}
        selectedVersion={selectedVersion}
        setSelectedVersion={setSelectedVersion}
        searchWord={searchWord}
        setSearchWord={setSearchWord}
        selectedOrganization={selectedOrganization}
        setSelectedOrganization={setSelectedOrganization}
      />
    </div>
  );
}

export default AppVersionReports;
